import { CurrencyTextField, NumberInput } from '@core/components/Inputs';
import { SelectAsyncInput, SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch, Tooltip } from '@material-ui/core';
import financeiroApi from 'app/services/api/financeiroApi';
import motivoDesoneracaoApi from 'app/services/api/servicoFiscal/motivoDesoneracaoApi';
import situacaoTributariaIcmsApi from 'app/services/api/servicoFiscal/situacaoTributariaIcmsApi';
import { GlobalContext } from 'app/store/globalcontext';
import { useFormikContext } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from './TabDadosFiscaisProduto';

const DadosFiscaisIcms = (context) => {
  const formik = useFormikContext();
  const styles = useStyles();

  const [toggle, setToggle] = useState(formik.values?.fiscal?.icms?.situacaoTributaria !== null);
  const optanteSimples = useContext(GlobalContext).empresa[0].optanteSimples;
  const [codigoSituacaoTributaria, setCodigoSituacaoTributaria] = useState();

  const icmsSituacaoTributaria = formik.values?.fiscal?.icms?.situacaoTributaria;
  useEffect(() => {
    setCodigoSituacaoTributaria(icmsSituacaoTributaria?.codigo);

    icmsSituacaoTributaria !== null && icmsSituacaoTributaria?.codigo !== undefined
      ? setToggle(true)
      : setToggle(false);
  }, [icmsSituacaoTributaria]);

  const listaModalidadeDeterminacao = [
    { id: 'MARGEM_VALOR_AGREGADO', title: '0 - Margem Valor Agregado (%)' },
    { id: 'PAUTA', title: '1 - Pauta (Valor)' },
    { id: 'PRECO_TABELADO_MAX', title: '2 - Preço Tabelado Máx. (valor)' },
    { id: 'VALOR_OPERACAO', title: '3 - Valor da operação' },
  ];

  const listaModalidadeDeterminacaoIcmsSt = [
    { id: 'PRECO_TABELADO_MAX', title: '0 - Preço tabelado ou máximo sugerido' },
    { id: 'LISTA_NEGATIVA', title: '1 - Lista Negativa (valor)' },
    { id: 'LISTA_POSITIVA', title: '2 - Lista Positiva (valor)' },
    { id: 'LISTA_NEUTRA', title: '3 - Lista Neutra (valor)' },
    { id: 'MARGEM_VALOR_AGREGADO', title: '4 - Margem Valor Agregado (%)' },
    { id: 'PAUTA', title: '5 - Pauta (valor)' },
    { id: 'VALOR_OPERACAO', title: '6 - Valor da Operação' },
  ];

  const { errors, touched, submitCount } = formik;

  const _errors = {
    situacaoTributaria:
      (submitCount || touched?.fiscal?.icms?.situacaoTributaria) && errors?.fiscal?.icms?.situacaoTributaria,
    ufIcmsStDevido: (submitCount || touched?.fiscal?.icms?.ufIcmsStDevido) && errors?.fiscal?.icms?.ufIcmsStDevido,
    modalidadeDeterminacaoBcIcmsST:
      (submitCount || touched?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST) &&
      errors?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST,
    motivoDesoneracao:
      (submitCount || touched?.fiscal?.icms?.motivoDesoneracao) && errors?.fiscal?.icms?.motivoDesoneracao,
    modalidadeDeterminacaoBC:
      (submitCount || touched?.fiscal?.icms?.modalidadeDeterminacaoBC) &&
      errors?.fiscal?.icms?.modalidadeDeterminacaoBC,
    valorBC: (submitCount || touched?.fiscal?.icms?.valorBC) && errors?.fiscal?.icms?.valorBC,
    aliquotaImposto: (submitCount || touched?.fiscal?.icms?.aliquotaImposto) && errors?.fiscal?.icms?.aliquotaImposto,
    aliquotaRelativoFcp:
      (submitCount || touched?.fiscal?.icms?.aliquotaRelativoFcp) && errors?.fiscal?.icms?.aliquotaRelativoFcp,
    valorBcFcp: (submitCount || touched?.fiscal?.icms?.valorBcFcp) && errors?.fiscal?.icms?.valorBcFcp,
    reducaoBcIcmsSt: (submitCount || touched?.fiscal?.icms?.reducaoBcIcmsSt) && errors?.fiscal?.icms?.reducaoBcIcmsSt,
    mvaIcmsSt: (submitCount || touched?.fiscal?.icms?.mvaIcmsSt) && errors?.fiscal?.icms?.mvaIcmsSt,
    aliquotaImpostoIcmsSt:
      (submitCount || touched?.fiscal?.icms?.aliquotaImpostoIcmsSt) && errors?.fiscal?.icms?.aliquotaImpostoIcmsSt,
    valorBcFcpRetidoSt:
      (submitCount || touched?.fiscal?.icms?.valorBcFcpRetidoSt) && errors?.fiscal?.icms?.valorBcFcpRetidoSt,
    fcpRetidoSt: (submitCount || touched?.fiscal?.icms?.fcpRetidoSt) && errors?.fiscal?.icms?.fcpRetidoSt,
    reducaoBC: (submitCount || touched?.fiscal?.icms?.reducaoBC) && errors?.fiscal?.icms?.reducaoBC,
    valorDesoneracao:
      (submitCount || touched?.fiscal?.icms?.valorDesoneracao) && errors?.fiscal?.icms?.valorDesoneracao,
    valorBcIcmsSt: (submitCount || touched?.fiscal?.icms?.valorBcIcmsSt) && errors?.fiscal?.icms?.valorBcIcmsSt,
    valorIcmsOperacao:
      (submitCount || touched?.fiscal?.icms?.valorIcmsOperacao) && errors?.fiscal?.icms?.valorIcmsOperacao,
    diferimento: (submitCount || touched?.fiscal?.icms?.diferimento) && errors?.fiscal?.icms?.diferimento,
    valorBcIcmsStRetido:
      (submitCount || touched?.fiscal?.icms?.valorBcIcmsStRetido) && errors?.fiscal?.icms?.valorBcIcmsStRetido,
    aliquotaSuportadaConsumidorFinal:
      (submitCount || touched?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal) &&
      errors?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal,
    valorIcmsStRetido:
      (submitCount || touched?.fiscal?.icms?.valorIcmsStRetido) && errors?.fiscal?.icms?.valorIcmsStRetido,
    valorIcmsProprioSubstituto:
      (submitCount || touched?.fiscal?.icms?.valorIcmsProprioSubstituto) &&
      errors?.fiscal?.icms?.valorIcmsProprioSubstituto,
    valorBcFcpRetidoAnteriormenteSt:
      (submitCount || touched?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt) &&
      errors?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt,
    fcpRetidoAnteriormenteSt:
      (submitCount || touched?.fiscal?.icms?.fcpRetidoAnteriormenteSt) &&
      errors?.fiscal?.icms?.fcpRetidoAnteriormenteSt,
    valorBCEfetiva: (submitCount || touched?.fiscal?.icms?.valorBCEfetiva) && errors?.fiscal?.icms?.valorBCEfetiva,
    aliquotaIcmsEfetiva:
      (submitCount || touched?.fiscal?.icms?.aliquotaIcmsEfetiva) && errors?.fiscal?.icms?.aliquotaIcmsEfetiva,
    aliquotaAplicavelCalculoCredito:
      (submitCount || touched?.fiscal?.icms?.aliquotaAplicavelCalculoCredito) &&
      errors?.fiscal?.icms?.aliquotaAplicavelCalculoCredito,
    valorCreditoIcms:
      (submitCount || touched?.fiscal?.icms?.valorCreditoIcms) && errors?.fiscal?.icms?.valorCreditoIcms,
    bcOperacaoPropria:
      (submitCount || touched?.fiscal?.icms?.bcOperacaoPropria) && errors?.fiscal?.icms?.bcOperacaoPropria,
    reducaoBCEfetiva:
      (submitCount || touched?.fiscal?.icms?.reducaoBCEfetiva) && errors?.fiscal?.icms?.reducaoBCEfetiva,
  };

  const limpaErrors = () => {
    let errors = formik.errors;
    if (toggle) {
      delete errors.fiscal?.icms;
    }
    formik.setErrors(errors);
  };

  const limpaToucheds = () => {
    let touched = formik.touched;
    if (toggle) {
      delete touched.fiscal?.icms;
    }
    formik.setTouched(touched);
  };

  const valorBcFcpValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBcFcp !== undefined &&
      formik.values?.fiscal?.icms?.valorBcFcp !== null &&
      formik.values?.fiscal?.icms?.valorBcFcp !== 0 &&
      formik.values?.fiscal?.icms?.valorBcFcp?.length !== 0
    );
  };

  const aliquotaRelativoFcpValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaRelativoFcp !== null &&
      formik.values?.fiscal?.icms?.aliquotaRelativoFcp !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaRelativoFcp !== undefined
    );
  };

  const valorBcFcpRetidoStValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBcFcpRetidoSt !== undefined &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoSt !== null &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoSt !== 0 &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoSt?.length !== 0
    );
  };

  const fcpRetidoStValido = () => {
    return (
      formik.values?.fiscal?.icms?.fcpRetidoSt !== null &&
      formik.values?.fiscal?.icms?.fcpRetidoSt !== 0 &&
      formik.values?.fiscal?.icms?.fcpRetidoSt !== undefined
    );
  };

  const aliquotaAplicavelCalculoCreditoValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== null &&
      formik.values?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaAplicavelCalculoCredito !== undefined
    );
  };

  const valorCreditoIcmsValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorCreditoIcms !== undefined &&
      formik.values?.fiscal?.icms?.valorCreditoIcms !== null &&
      formik.values?.fiscal?.icms?.valorCreditoIcms !== 0 &&
      formik.values?.fiscal?.icms?.valorCreditoIcms?.length !== 0
    );
  };

  const valorDesoneracaoValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorDesoneracao !== undefined &&
      formik.values?.fiscal?.icms?.valorDesoneracao !== null &&
      formik.values?.fiscal?.icms?.valorDesoneracao !== 0 &&
      formik.values?.fiscal?.icms?.valorDesoneracao?.length !== 0
    );
  };

  const motivoDesoneracaoValido = () => {
    return (
      formik.values?.fiscal?.icms?.motivoDesoneracao !== undefined &&
      formik.values?.fiscal?.icms?.motivoDesoneracao !== null &&
      formik.values?.fiscal?.icms?.motivoDesoneracao?.codigo !== undefined
    );
  };

  const valorBcIcmsStRetidoValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBcIcmsStRetido !== undefined &&
      formik.values?.fiscal?.icms?.valorBcIcmsStRetido !== null &&
      formik.values?.fiscal?.icms?.valorBcIcmsStRetido !== 0 &&
      formik.values?.fiscal?.icms?.valorBcIcmsStRetido?.length !== 0
    );
  };

  const aliquotaSuportadaConsumidorFinalValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal !== null &&
      formik.values?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal !== undefined
    );
  };

  const valorIcmsStRetidoValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorIcmsStRetido !== undefined &&
      formik.values?.fiscal?.icms?.valorIcmsStRetido !== null &&
      formik.values?.fiscal?.icms?.valorIcmsStRetido !== 0 &&
      formik.values?.fiscal?.icms?.valorIcmsStRetido.length !== 0
    );
  };

  const valorBcFcpRetidoAnteriormenteStValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt !== undefined &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt !== null &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt !== 0 &&
      formik.values?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt?.length !== 0
    );
  };

  const fcpRetidoAnteriormenteStValido = () => {
    return (
      formik.values?.fiscal?.icms?.fcpRetidoAnteriormenteSt !== null &&
      formik.values?.fiscal?.icms?.fcpRetidoAnteriormenteSt !== 0 &&
      formik.values?.fiscal?.icms?.fcpRetidoAnteriormenteSt !== undefined
    );
  };

  const valorBCEfetivaValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBCEfetiva !== undefined &&
      formik.values?.fiscal?.icms?.valorBCEfetiva !== null &&
      formik.values?.fiscal?.icms?.valorBCEfetiva !== 0 &&
      formik.values?.fiscal?.icms?.valorBCEfetiva?.length !== 0
    );
  };

  const reducaoBCEfetivaValido = () => {
    return (
      formik.values?.fiscal?.icms?.reducaoBCEfetiva !== null &&
      formik.values?.fiscal?.icms?.reducaoBCEfetiva !== 0 &&
      formik.values?.fiscal?.icms?.reducaoBCEfetiva !== undefined
    );
  };

  const aliquotaIcmsEfetivaValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaIcmsEfetiva !== null &&
      formik.values?.fiscal?.icms?.aliquotaIcmsEfetiva !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaIcmsEfetiva !== undefined
    );
  };

  const modalidadeDeterminacaoBCValido = () => {
    return (
      formik.values?.fiscal?.icms?.modalidadeDeterminacaoBC !== null &&
      formik.values?.fiscal?.icms?.modalidadeDeterminacaoBC !== undefined
    );
  };

  const valorBcValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBC !== undefined &&
      formik.values?.fiscal?.icms?.valorBC !== null &&
      formik.values?.fiscal?.icms?.valorBC !== 0 &&
      formik.values?.fiscal?.icms?.valorBC?.length !== 0
    );
  };

  const aliquotaImpostoValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaImposto !== null &&
      formik.values?.fiscal?.icms?.aliquotaImposto !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaImposto !== undefined
    );
  };

  const modalidadeDeterminacaoBcIcmsSTValido = () => {
    return (
      formik.values?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST !== null &&
      formik.values?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST !== undefined
    );
  };

  const valorBcIcmsStValido = () => {
    return (
      formik.values?.fiscal?.icms?.valorBcIcmsSt !== undefined &&
      formik.values?.fiscal?.icms?.valorBcIcmsSt !== null &&
      formik.values?.fiscal?.icms?.valorBcIcmsSt !== 0 &&
      formik.values?.fiscal?.icms?.valorBcIcmsSt?.length !== 0
    );
  };

  const aliquotaImpostoIcmsStValido = () => {
    return (
      formik.values?.fiscal?.icms?.aliquotaImpostoIcmsSt !== null &&
      formik.values?.fiscal?.icms?.aliquotaImpostoIcmsSt !== 0 &&
      formik.values?.fiscal?.icms?.aliquotaImpostoIcmsSt !== undefined
    );
  };

  const bcOperacaoPropriaValido = () => {
    return (
      formik.values?.fiscal?.icms?.bcOperacaoPropria !== null &&
      formik.values?.fiscal?.icms?.bcOperacaoPropria !== 0 &&
      formik.values?.fiscal?.icms?.bcOperacaoPropria !== undefined
    );
  };

  const ufIcmsStDevidoValido = () => {
    return (
      formik.values?.fiscal?.icms?.ufIcmsStDevido !== null &&
      formik.values?.fiscal?.icms?.ufIcmsStDevido?.id !== undefined
    );
  };

  const RNE718 = () => {
    let valido = false;

    if (valorBcFcpValido() || aliquotaRelativoFcpValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE719 = () => {
    let valido = false;

    if (valorBcFcpRetidoStValido() || fcpRetidoStValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE720 = () => {
    let valido = false;

    if (
      valorBcFcpRetidoStValido() ||
      fcpRetidoStValido() ||
      aliquotaAplicavelCalculoCreditoValido() ||
      valorCreditoIcmsValido()
    ) {
      valido = true;
    }

    return valido;
  };

  const RNE721 = () => {
    let valido = false;

    if (valorDesoneracaoValido() || motivoDesoneracaoValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE723 = () => {
    let valido = false;

    if (valorBcIcmsStRetidoValido() || aliquotaSuportadaConsumidorFinalValido() || valorIcmsStRetidoValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE724 = () => {
    let valido = false;

    if (valorBcFcpRetidoAnteriormenteStValido() || fcpRetidoAnteriormenteStValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE725 = () => {
    let valido = false;

    if (valorBCEfetivaValido() || reducaoBCEfetivaValido() || aliquotaIcmsEfetivaValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE726 = () => {
    let valido = false;

    if (modalidadeDeterminacaoBCValido() || valorBcValido() || aliquotaImpostoValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE727 = () => {
    let valido = false;

    if (modalidadeDeterminacaoBcIcmsSTValido() || valorBcIcmsStValido() || aliquotaImpostoIcmsStValido()) {
      valido = true;
    }

    return valido;
  };

  const RNE728 = () => {
    let valido = false;

    if (
      modalidadeDeterminacaoBcIcmsSTValido() ||
      valorBcIcmsStValido() ||
      aliquotaImpostoIcmsStValido() ||
      bcOperacaoPropriaValido() ||
      ufIcmsStDevidoValido()
    ) {
      valido = true;
    }

    return valido;
  };

  const RNE729 = () => {
    let valido = false;

    if (aliquotaAplicavelCalculoCreditoValido() || valorCreditoIcmsValido()) {
      valido = true;
    }

    return valido;
  };

  const exibeSituacaoTributaria = () => {
    if (toggle) {
      return (
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <SelectAsyncInput
            id={`${context.name}.situacaoTributaria`}
            name={`${context.name}.situacaoTributaria`}
            label="Situação tributária"
            autoFocus
            required={true}
            value={formik.values?.fiscal?.icms?.situacaoTributaria}
            onBlur={formik.handleBlur}
            error={_errors.situacaoTributaria}
            touched={!!_errors.situacaoTributaria}
            fetchOnFocus
            onChange={(event, value) => {
              limpaErrors();
              limpaToucheds();

              setCodigoSituacaoTributaria(value?.codigo);
              formik.setFieldValue(`${context.name}.codigoTributario`, value?.codigo);

              formik.setFieldValue(`${context.name}.situacaoTributaria.id`, value?.id);
              formik.setFieldValue(`${context.name}.situacaoTributaria.codigo`, value?.codigo);
              formik.setFieldValue(`${context.name}.situacaoTributaria.descricao`, value?.descricao);
            }}
            getOptionKey={(option) => {
              return option?.id;
            }}
            getOptionLabel={(option) => {
              return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
            }}
            fetchData={async (query = '', next = 0) => {
              if (typeof query === 'object') {
                query = '';
              }
              const response = await situacaoTributariaIcmsApi.pesquisar({
                size: 100,
                sort: 'codigo',
                page: next,
                q: query,
                optanteSimples: optanteSimples,
              });

              const data = response?.data || [];

              return { data };
            }}
            renderOption={(option) => {
              const labelOption = option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
              return (
                <Tooltip title={labelOption}>
                  <div className={styles.container} style={{ maxWidth: '100%' }}>
                    {labelOption}
                  </div>
                </Tooltip>
              );
            }}
          />
        </Grid>
      );
    }
  };

  const exibeAliquotaAplicavelCalculoCredito = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota aplicável de cálculo de crédito (%)"
          id={`${context.name}.aliquotaAplicavelCalculoCredito`}
          name={`${context.name}.aliquotaAplicavelCalculoCredito`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaAplicavelCalculoCredito}
          error={_errors.aliquotaAplicavelCalculoCredito}
          touched={!!_errors.aliquotaAplicavelCalculoCredito}
        />
      </Grid>
    );
  };

  const exibeAliquotaImposto = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota do imposto (%)"
          id={`${context.name}.aliquotaImposto`}
          name={`${context.name}.aliquotaImposto`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          displayType="text"
          decimalSeparator=","
          isNumericString={true}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaImposto}
          error={_errors.aliquotaImposto}
          touched={!!_errors.aliquotaImposto}
        />
      </Grid>
    );
  };

  const exibeAliquotaSuportadaConsumidorFinal = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota suportada pelo Consumidor Final (%)"
          id={`${context.name}.aliquotaSuportadaConsumidorFinal`}
          name={`${context.name}.aliquotaSuportadaConsumidorFinal`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal}
          error={_errors.aliquotaSuportadaConsumidorFinal}
          touched={!!_errors.aliquotaSuportadaConsumidorFinal}
        />
      </Grid>
    );
  };

  const exibeValorCreditoIcms = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorCreditoIcms`}
          name={`${context.name}.valorCreditoIcms`}
          value={formik.values?.fiscal?.icms?.valorCreditoIcms}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorCreditoIcms}
          touched={!!_errors.valorCreditoIcms}
          helperText={_errors.valorCreditoIcms}
          fullWidth
          variant="outlined"
          label="Valor de crédito do ICMS (R$)"
        />
      </Grid>
    );
  };

  const exibeValorBcFcpRetidoSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBcFcpRetidoSt`}
          name={`${context.name}.valorBcFcpRetidoSt`}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          value={formik.values?.fiscal?.icms?.valorBcFcpRetidoSt}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBcFcpRetidoSt}
          touched={!!_errors.valorBcFcpRetidoSt}
          helperText={_errors.valorBcFcpRetidoSt}
          fullWidth
          variant="outlined"
          label="Valor da BC do FCP retido por ST (R$)"
        />
      </Grid>
    );
  };

  const exibeValorBc = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBC`}
          name={`${context.name}.valorBC`}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          value={formik.values?.fiscal?.icms?.valorBC}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBC}
          touched={!!_errors.valorBC}
          helperText={_errors.valorBC}
          fullWidth
          variant="outlined"
          label="Valor da BC (R$)"
        />
      </Grid>
    );
  };

  const exibeFcpRetidoSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="FCP retido por ST (%)"
          id={`${context.name}.fcpRetidoSt`}
          name={`${context.name}.fcpRetidoSt`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.fcpRetidoSt}
          error={_errors.fcpRetidoSt}
          touched={!!_errors.fcpRetidoSt}
        />
      </Grid>
    );
  };

  const exibeUfIcmsStDevido = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <SelectAsyncInput
          id={`${context.name}.ufIcmsStDevido`}
          name={`${context.name}.ufIcmsStDevido`}
          label="UF para qual é devido o ICMS ST"
          value={formik.values?.fiscal?.icms?.ufIcmsStDevido}
          fetchOnFocus
          hidePlaceholder
          onBlur={formik.handleBlur}
          error={_errors.ufIcmsStDevido}
          touched={!!_errors.ufIcmsStDevido}
          required={obrigatorio}
          onChange={(event, value) => {
            formik.handleChange({
              target: {
                id: `${context.name}.ufIcmsStDevido`,
                value,
              },
            });
          }}
          getOptionKey={(option) => {
            return option?.id;
          }}
          getOptionLabel={(option) => {
            return option?.nome ? `${option.nome}` : '';
          }}
          fetchData={async (query = '', next = 0) => {
            const response = await financeiroApi.get('/api/v1/backend/uf');
            const data = response?.data.content || [];
            return { data, nextPage: next, totalItems: response?.data.totalElements };
          }}
          renderOption={(option) => {
            const labelOption = option?.nome ? `${option.nome}` : '';
            return (
              <Tooltip title={labelOption}>
                <div className={styles.container} style={{ maxWidth: '100%' }}>
                  {labelOption}
                </div>
              </Tooltip>
            );
          }}
        />
      </Grid>
    );
  };

  const exibeBcOperacaoPropria = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="BC da operação própria (%)"
          id={`${context.name}.bcOperacaoPropria`}
          name={`${context.name}.bcOperacaoPropria`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.bcOperacaoPropria}
          error={_errors.bcOperacaoPropria}
          touched={!!_errors.bcOperacaoPropria}
        />
      </Grid>
    );
  };

  const exibeAliquotaImpostoIcmsSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota do imposto do ICMS ST (%)"
          id={`${context.name}.aliquotaImpostoIcmsSt`}
          name={`${context.name}.aliquotaImpostoIcmsSt`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaImpostoIcmsSt}
          error={_errors.aliquotaImpostoIcmsSt}
          touched={!!_errors.aliquotaImpostoIcmsSt}
        />
      </Grid>
    );
  };

  const exibeValorBcIcmsSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBcIcmsSt`}
          name={`${context.name}.valorBcIcmsSt`}
          value={formik.values?.fiscal?.icms?.valorBcIcmsSt}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBcIcmsSt}
          touched={!!_errors.valorBcIcmsSt}
          helperText={_errors.valorBcIcmsSt}
          fullWidth
          variant="outlined"
          label="Valor da BC do ICMS ST (R$)"
        />
      </Grid>
    );
  };

  const exibeValorBcIcmsStRetido = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBcIcmsStRetido`}
          name={`${context.name}.valorBcIcmsStRetido`}
          value={formik.values?.fiscal?.icms?.valorBcIcmsStRetido}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBcIcmsStRetido}
          touched={!!_errors.valorBcIcmsStRetido}
          helperText={_errors.valorBcIcmsStRetido}
          fullWidth
          variant="outlined"
          label="Valor da BC do ICMS ST retido (R$)"
        />
      </Grid>
    );
  };

  const exibeReducaoBcIcmsSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Redução de BC do ICMS ST (%)"
          id={`${context.name}.reducaoBcIcmsSt`}
          name={`${context.name}.reducaoBcIcmsSt`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.reducaoBcIcmsSt}
          error={_errors.reducaoBcIcmsSt}
          touched={!!_errors.reducaoBcIcmsSt}
        />
      </Grid>
    );
  };

  const exibeReducaoBc = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Redução de BC (%)"
          id={`${context.name}.reducaoBC`}
          name={`${context.name}.reducaoBC`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.reducaoBC}
          error={_errors.reducaoBC}
          touched={!!_errors.reducaoBC}
        />
      </Grid>
    );
  };

  const exibeMvaIcmsSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="MVA do ICMS ST (%)"
          id={`${context.name}.mvaIcmsSt`}
          name={`${context.name}.mvaIcmsSt`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.mvaIcmsSt}
          error={_errors.mvaIcmsSt}
          touched={!!_errors.mvaIcmsSt}
        />
      </Grid>
    );
  };

  const exibeAliquotaRelativoFcp = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota relativo ao FCP (%)"
          id={`${context.name}.aliquotaRelativoFcp`}
          name={`${context.name}.aliquotaRelativoFcp`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaRelativoFcp}
          error={_errors.aliquotaRelativoFcp}
          touched={!!_errors.aliquotaRelativoFcp}
        />
      </Grid>
    );
  };

  const exibeValorBcFcp = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBcFcp`}
          name={`${context.name}.valorBcFcp`}
          value={formik.values?.fiscal?.icms?.valorBcFcp}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBcFcp}
          touched={!!_errors.valorBcFcp}
          helperText={_errors.valorBcFcp}
          fullWidth
          variant="outlined"
          label="Valor da BC do FCP (R$)"
        />
      </Grid>
    );
  };

  const exibeValorDesoneracao = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorDesoneracao`}
          name={`${context.name}.valorDesoneracao`}
          value={formik.values?.fiscal?.icms?.valorDesoneracao}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorDesoneracao}
          touched={!!_errors.valorDesoneracao}
          helperText={_errors.valorDesoneracao}
          fullWidth
          variant="outlined"
          label="Valor da desoneração (R$)"
        />
      </Grid>
    );
  };

  const exibeValorIcmsOperacao = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorIcmsOperacao`}
          name={`${context.name}.valorIcmsOperacao`}
          value={formik.values?.fiscal?.icms?.valorIcmsOperacao}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorIcmsOperacao}
          touched={!!_errors.valorIcmsOperacao}
          helperText={_errors.valorIcmsOperacao}
          fullWidth
          variant="outlined"
          label="Valor do ICMS da operação (R$)"
        />
      </Grid>
    );
  };

  const exibeValorIcmsStRetido = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorIcmsStRetido`}
          name={`${context.name}.valorIcmsStRetido`}
          value={formik.values?.fiscal?.icms?.valorIcmsStRetido}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorIcmsStRetido}
          touched={!!_errors.valorIcmsStRetido}
          helperText={_errors.valorIcmsStRetido}
          fullWidth
          variant="outlined"
          label="Valor do ICMS ST retido (R$)"
        />
      </Grid>
    );
  };

  const exibeValorIcmsProprioSubstituto = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorIcmsProprioSubstituto`}
          name={`${context.name}.valorIcmsProprioSubstituto`}
          value={formik.values?.fiscal?.icms?.valorIcmsProprioSubstituto}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorIcmsProprioSubstituto}
          touched={!!_errors.valorIcmsProprioSubstituto}
          helperText={_errors.valorIcmsProprioSubstituto}
          fullWidth
          variant="outlined"
          label="Valor do ICMS próprio do Substituto (R$)"
        />
      </Grid>
    );
  };

  const exibeValorBcFcpRetidoAnteriormenteSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBcFcpRetidoAnteriormenteSt`}
          name={`${context.name}.valorBcFcpRetidoAnteriormenteSt`}
          value={formik.values?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBcFcpRetidoAnteriormenteSt}
          touched={!!_errors.valorBcFcpRetidoAnteriormenteSt}
          helperText={_errors.valorBcFcpRetidoAnteriormenteSt}
          fullWidth
          variant="outlined"
          label="Valor da BC do FCP retido anteriormente por ST (R$)"
        />
      </Grid>
    );
  };

  const exibeValorBCEfetiva = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <CurrencyTextField
          id={`${context.name}.valorBCEfetiva`}
          name={`${context.name}.valorBCEfetiva`}
          value={formik.values?.fiscal?.icms?.valorBCEfetiva}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          onChange={(e, value) => {
            formik.handleChange({
              target: {
                id: e.target.id,
                value: e.target.value === '' ? '' : value,
              },
            });
          }}
          currencySymbol=""
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="9999999999999"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={_errors.valorBCEfetiva}
          touched={!!_errors.valorBCEfetiva}
          helperText={_errors.valorBCEfetiva}
          fullWidth
          variant="outlined"
          label="Valor da BC efetiva (R$)"
        />
      </Grid>
    );
  };

  const exibeDiferimento = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Diferimento (%)"
          id={`${context.name}.diferimento`}
          name={`${context.name}.diferimento`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.diferimento}
          error={_errors.diferimento}
          touched={!!_errors.diferimento}
        />
      </Grid>
    );
  };

  const exibeFcpRetidoAnteriormenteSt = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="FCP retido anteriormente por ST (%)"
          id={`${context.name}.fcpRetidoAnteriormenteSt`}
          name={`${context.name}.fcpRetidoAnteriormenteSt`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.fcpRetidoAnteriormenteSt}
          error={_errors.fcpRetidoAnteriormenteSt}
          touched={!!_errors.fcpRetidoAnteriormenteSt}
        />
      </Grid>
    );
  };

  const exibeReducaoBCEfetiva = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Redução da BC efetiva (%)"
          id={`${context.name}.reducaoBCEfetiva`}
          name={`${context.name}.reducaoBCEfetiva`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.reducaoBCEfetiva}
          error={_errors.reducaoBCEfetiva}
          touched={!!_errors.reducaoBCEfetiva}
        />
      </Grid>
    );
  };

  const exibeAliquotaIcmsEfetiva = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <NumberInput
          label="Alíquota do ICMS efetiva (%)"
          id={`${context.name}.aliquotaIcmsEfetiva`}
          name={`${context.name}.aliquotaIcmsEfetiva`}
          required={obrigatorio}
          decimalScale={4}
          fixedDecimalScale={true}
          decimalSeparator=","
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isAllowed={(values) => !values.floatValue || values.floatValue < 1000}
          allowNegative={false}
          value={formik.values?.fiscal?.icms?.aliquotaIcmsEfetiva}
          error={_errors.aliquotaIcmsEfetiva}
          touched={!!_errors.aliquotaIcmsEfetiva}
        />
      </Grid>
    );
  };

  const exibeModalidadeDeterminacaoBcIcmsST = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectInput
          id={`${context.name}.modalidadeDeterminacaoBcIcmsST`}
          name={`${context.name}.modalidadeDeterminacaoBcIcmsST`}
          label="Modalidade de determinação da BC do ICMS ST"
          onChange={(e, value) => {
            const event = {
              target: { id: `${context.name}.modalidadeDeterminacaoBcIcmsST`, value: e.target.value },
            };
            formik.handleChange(event);
          }}
          required={obrigatorio}
          onBlur={formik.handleBlur}
          value={formik.values?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST}
          options={listaModalidadeDeterminacaoIcmsSt}
          error={_errors.modalidadeDeterminacaoBcIcmsST}
          touched={!!_errors.modalidadeDeterminacaoBcIcmsST}
        />
      </Grid>
    );
  };

  const exibeMotivoDesoneracao = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectAsyncInput
          id={`${context.name}.motivoDesoneracao`}
          name={`${context.name}.motivoDesoneracao`}
          label="Motivo da desoneração"
          required={obrigatorio}
          hidePlaceholder
          value={formik.values?.fiscal?.icms?.motivoDesoneracao}
          onBlur={formik.handleBlur}
          error={_errors.motivoDesoneracao}
          touched={!!_errors.motivoDesoneracao}
          fetchOnFocus
          onChange={(event, value) => {
            formik.handleChange({
              target: {
                id: `${context.name}.motivoDesoneracao`,
                value,
              },
            });
          }}
          getOptionKey={(option) => {
            return option?.id;
          }}
          getOptionLabel={(option) => {
            return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
          }}
          fetchData={async (query = '', next = 0) => {
            if (typeof query === 'object') {
              query = '';
            }
            const response = await motivoDesoneracaoApi.pesquisar({
              size: 100,
              sort: 'codigo',
              page: next,
              q: query,
            });

            const data = response?.data || [];

            return { data };
          }}
          renderOption={(option) => {
            const labelOption = option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
            return (
              <Tooltip title={labelOption}>
                <div className={styles.container} style={{ maxWidth: '100%' }}>
                  {labelOption}
                </div>
              </Tooltip>
            );
          }}
        />
      </Grid>
    );
  };

  const exibeModalidadeDeterminacaoBC = (obrigatorio) => {
    return (
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectInput
          id={`${context.name}.modalidadeDeterminacaoBC`}
          name={`${context.name}.modalidadeDeterminacaoBC`}
          label="Modalidade de determinação da BC"
          onChange={(e, value) => {
            const event = {
              target: { id: `${context.name}.modalidadeDeterminacaoBC`, value: e.target.value },
            };
            formik.handleChange(event);
          }}
          value={formik.values?.fiscal?.icms?.modalidadeDeterminacaoBC}
          options={listaModalidadeDeterminacao}
          error={_errors.modalidadeDeterminacaoBC}
          required={obrigatorio}
          touched={!!_errors.modalidadeDeterminacaoBC}
          onBlur={formik.handleBlur}
        />
      </Grid>
    );
  };

  const exibeCamposCodigo00 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC(true)}
        {exibeValorBc(true)}
        {exibeAliquotaImposto(true)}
        {exibeAliquotaRelativoFcp()}
      </>
    );
  };

  const exibeCamposCodigo10 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC(true)}
        {exibeValorBc(true)}
        {exibeAliquotaImposto(true)}
        {exibeValorBcFcp(RNE718())}
        {exibeAliquotaRelativoFcp(RNE718())}
        {exibeModalidadeDeterminacaoBcIcmsST(true)}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(true)}
        {exibeMvaIcmsSt()}
        {exibeAliquotaImpostoIcmsSt(true)}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
      </>
    );
  };

  const exibeCamposCodigo20 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC(true)}
        {exibeReducaoBc(true)}
        {exibeValorBc(true)}
        {exibeAliquotaImposto(true)}
        {exibeValorBcFcp(RNE718())}
        {exibeAliquotaRelativoFcp(RNE718())}
        {exibeValorDesoneracao(RNE721())}
        {exibeMotivoDesoneracao(RNE721())}
      </>
    );
  };

  const exibeCamposCodigo30 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBcIcmsST(true)}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(true)}
        {exibeMvaIcmsSt()}
        {exibeAliquotaImpostoIcmsSt(true)}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
        {exibeValorDesoneracao(RNE721())}
        {exibeMotivoDesoneracao(RNE721())}
      </>
    );
  };

  const exibeCamposCodigo40_41_50 = () => {
    return (
      <>
        {exibeValorDesoneracao(RNE721())}
        {exibeMotivoDesoneracao(RNE721())}
      </>
    );
  };

  const exibeCamposCodigo51 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC()}
        {exibeReducaoBc()}
        {exibeValorBc()}
        {exibeAliquotaImposto()}
        {exibeValorIcmsOperacao()}
        {exibeDiferimento()}
        {exibeValorBcFcp(RNE718())}
        {exibeAliquotaRelativoFcp(RNE718())}
      </>
    );
  };

  const exibeCamposCodigo60 = () => {
    return (
      <>
        {exibeValorBcIcmsStRetido(RNE723())}
        {exibeAliquotaSuportadaConsumidorFinal(RNE723())}
        {exibeValorIcmsStRetido(RNE723())}
        {exibeValorIcmsProprioSubstituto()}
        {exibeValorBcFcpRetidoAnteriormenteSt(RNE724())}
        {exibeFcpRetidoAnteriormenteSt(RNE724())}
        {exibeValorBCEfetiva(RNE725())}
        {exibeReducaoBCEfetiva(RNE725())}
        {exibeAliquotaIcmsEfetiva(RNE725())}
      </>
    );
  };

  const exibeCamposCodigo70 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC()}
        {exibeReducaoBc(true)}
        {exibeValorBc(true)}
        {exibeAliquotaImposto(true)}
        {exibeValorBcFcp(RNE718())}
        {exibeAliquotaRelativoFcp(RNE718())}
        {exibeModalidadeDeterminacaoBcIcmsST(true)}
        {exibeMvaIcmsSt()}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(true)}
        {exibeAliquotaImpostoIcmsSt(true)}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
        {exibeValorDesoneracao(RNE721())}
        {exibeMotivoDesoneracao(RNE721())}
      </>
    );
  };

  const exibeCamposCodigo90 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC(RNE726())}
        {exibeReducaoBc()}
        {exibeValorBc(RNE726())}
        {exibeAliquotaImposto(RNE726())}
        {exibeValorBcFcp(RNE718())}
        {exibeAliquotaRelativoFcp(RNE718())}
        {exibeModalidadeDeterminacaoBcIcmsST(RNE727())}
        {exibeMvaIcmsSt()}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(RNE727())}
        {exibeAliquotaImpostoIcmsSt(RNE727())}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
        {exibeValorDesoneracao(RNE721())}
        {exibeMotivoDesoneracao(RNE721())}
      </>
    );
  };

  const exibeCamposCodigo101 = () => {
    return (
      <>
        {exibeAliquotaAplicavelCalculoCredito(true)}
        {exibeValorCreditoIcms(true)}
      </>
    );
  };

  const exibeCamposCodigo201 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBcIcmsST(true)}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(true)}
        {exibeMvaIcmsSt()}
        {exibeAliquotaImpostoIcmsSt(true)}
        {exibeValorBcFcpRetidoSt(RNE720())}
        {exibeFcpRetidoSt(RNE720())}
        {exibeAliquotaAplicavelCalculoCredito(RNE720())}
        {exibeValorCreditoIcms(RNE720())}
      </>
    );
  };

  const exibeCamposCodigo202e203 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBcIcmsST(true)}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(true)}
        {exibeMvaIcmsSt()}
        {exibeAliquotaImpostoIcmsSt(true)}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
      </>
    );
  };

  const exibeCamposCodigo500 = () => {
    return (
      <>
        {exibeValorBcIcmsStRetido(RNE723())}
        {exibeAliquotaSuportadaConsumidorFinal(RNE723())}
        {exibeValorIcmsProprioSubstituto()}
        {exibeValorIcmsStRetido(RNE723())}
        {exibeValorBcFcpRetidoAnteriormenteSt(RNE724())}
        {exibeFcpRetidoAnteriormenteSt(RNE724())}
        {exibeValorBCEfetiva(RNE725())}
        {exibeReducaoBCEfetiva(RNE725())}
        {exibeAliquotaIcmsEfetiva(RNE725())}
      </>
    );
  };

  const exibeCamposCodigo900 = () => {
    return (
      <>
        {exibeModalidadeDeterminacaoBC(RNE726())}
        {exibeReducaoBc()}
        {exibeValorBc(RNE726())}
        {exibeAliquotaImposto(RNE726())}
        {exibeModalidadeDeterminacaoBcIcmsST(RNE728())}
        {exibeMvaIcmsSt()}
        {exibeReducaoBcIcmsSt()}
        {exibeValorBcIcmsSt(RNE728())}
        {exibeAliquotaImpostoIcmsSt(RNE728())}
        {exibeBcOperacaoPropria(RNE728())}
        {exibeUfIcmsStDevido(RNE728())}
        {exibeValorBcFcpRetidoSt(RNE719())}
        {exibeFcpRetidoSt(RNE719())}
        {exibeAliquotaAplicavelCalculoCredito(RNE729())}
        {exibeValorCreditoIcms(RNE729())}
      </>
    );
  };

  return (
    <>
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <FormControlLabel
            control={
              <Switch
                id={`${context.name}.possuiIcms`}
                name={`${context.name}.possuiIcms`}
                value={toggle}
                checked={toggle}
                onChange={({ target: { checked } }) => {
                  formik.setFieldValue(`${context.name}.possuiIcms`, checked);
                  setToggle(checked);

                  if (checked === false) {
                    formik.setFieldValue(`${context.name}`, {});
                  }

                  let errors = formik.errors;
                  delete errors.fiscal?.icms;
                  formik.setErrors(errors);
                  let touched = formik.touched;
                  delete touched.fiscal?.icms;
                  formik.setTouched(touched);
                }}
                color="primary"
              />
            }
            label="ICMS"
          />
        </Grid>
        {exibeSituacaoTributaria()}
        {toggle && codigoSituacaoTributaria ? (
          <>
            {codigoSituacaoTributaria === '00' ? exibeCamposCodigo00() : null}

            {codigoSituacaoTributaria === '10' ? exibeCamposCodigo10() : null}

            {codigoSituacaoTributaria === '20' ? exibeCamposCodigo20() : null}

            {codigoSituacaoTributaria === '30' ? exibeCamposCodigo30() : null}

            {codigoSituacaoTributaria === '40' || codigoSituacaoTributaria === '41' || codigoSituacaoTributaria === '50'
              ? exibeCamposCodigo40_41_50()
              : null}

            {codigoSituacaoTributaria === '51' ? exibeCamposCodigo51() : null}

            {codigoSituacaoTributaria === '60' ? exibeCamposCodigo60() : null}

            {codigoSituacaoTributaria === '70' ? exibeCamposCodigo70() : null}

            {codigoSituacaoTributaria === '90' ? exibeCamposCodigo90() : null}

            {codigoSituacaoTributaria === '101' ? exibeCamposCodigo101() : null}

            {codigoSituacaoTributaria === '201' ? exibeCamposCodigo201() : null}

            {codigoSituacaoTributaria === '202' || codigoSituacaoTributaria === '203'
              ? exibeCamposCodigo202e203()
              : null}

            {codigoSituacaoTributaria === '500' ? exibeCamposCodigo500() : null}

            {codigoSituacaoTributaria === '900' ? exibeCamposCodigo900() : null}
          </>
        ) : null}
      </Grid>
    </>
  );
};

export default DadosFiscaisIcms;
